import {OrderItemDTO} from "@features/sales/domain/models/order/order-item.model";
import {AdditionalProductDTO, DiscountDTO, Item} from "@features/sales/domain/models/cart/item.model";

export class OrderItem {
  private readonly _item: Item;
  private readonly _quantity: number;
  private readonly _amount: number;
  private readonly _customUnitPrice?: number;
  private readonly _discount?: DiscountDTO;
  private readonly _additionalProduct?: AdditionalProductDTO;

  constructor(dto: OrderItemDTO) {
    this._item = dto.item;
    this._amount = dto.amount;
    this._discount = dto.discount;
    this._quantity = dto.quantity;
    this._customUnitPrice = dto.customUnitPrice;
    this._additionalProduct = dto.additionalProduct;
  }

  get quantity(): number {
    return this._quantity;
  }

  get amount(): number {
    return this._amount;
  }

  get discount(): DiscountDTO | undefined {
    return this._discount;
  }

  toDTO(): OrderItemDTO {
    return {
      item: this._item,
      amount: this._amount,
      discount: this._discount,
      quantity: this._quantity,
      customUnitPrice: this._customUnitPrice,
      additionalProduct: this._additionalProduct,
    };
  }
}
